import * as CoverActionTypes from '../actions/openCovers';

import initialState from './initialState';

import { errorResponseHandler } from '../utils/error-utils';

export default (state=initialState.covers, action) => {
   const { payload, type } = action;

   switch(type) {

        case CoverActionTypes.LIST_COVERS:
        case CoverActionTypes.LIST_COVERS_PENDING:
            return { ...state, coversLoading: true, openCovers: [] }

        case CoverActionTypes.LIST_COVERS_REJECTED:
            return { ...state, coversLoading: false, ...errorResponseHandler(payload, 'OpenCoversList') }

        case CoverActionTypes.LIST_COVERS_FULFILLED:
            return { ...state, coversLoading: false, openCovers: payload.data }
        

        case CoverActionTypes.LIST_COMPANIES:
            case CoverActionTypes.LIST_COMPANIES_PENDING:
                return { ...state, companiesLoading: true, companies: [] }
    
            case CoverActionTypes.LIST_COMPANIES_REJECTED:
                return { ...state, companiesLoading: false, ...errorResponseHandler(payload, 'CompaniesList') }
    
            case CoverActionTypes.LIST_COMPANIES_FULFILLED:
                return { ...state, companiesLoading: false, companies: payload.data }
        

        case CoverActionTypes.LIST_CORPORATES:
        case CoverActionTypes.LIST_CORPORATES_PENDING:
            return { ...state, corporatesLoading: true, corporates: [] }

        case CoverActionTypes.LIST_CORPORATES_REJECTED:
            return { ...state, corporatesLoading: false, ...errorResponseHandler(payload, 'CorporatesList') }

        case CoverActionTypes.LIST_CORPORATES_FULFILLED:
            return { ...state, corporatesLoading: false, corporates: payload.data }
        
        
        case CoverActionTypes.CREATE_COVER:
        case CoverActionTypes.CREATE_COVER_PENDING:
            return { ...state, createCoverLoading: true }

        case CoverActionTypes.CREATE_COVER_REJECTED:
            const openCover = payload.data.open_cover ? payload.data.open_cover[0] : {};

            const errorResponse = {
                data: typeof openCover === 'string' ? 
                    { failed: [payload.data.open_cover] } : payload.data.open_cover[0],
                status: payload.status
            };

         
           return { ...state, createCoverLoading: false, ...errorResponseHandler(errorResponse, 'CreateCover') }

        case CoverActionTypes.CREATE_COVER_FULFILLED:
            const createdOpenCover = payload.data;
            return Object.assign({}, state,{
                openCovers:[
                    createdOpenCover,
                    ...state.openCovers
                ],
                successCreateCover: true,
                createCoverLoading: false

            })

        case CoverActionTypes.CREATE_COMPANY:
        case CoverActionTypes.CREATE_COMPANY_PENDING:
            return { ...state, createCompanyLoading: true }

        case CoverActionTypes.CREATE_COMPANY_REJECTED:
            return { ...state, createCompanyLoading: false, ...errorResponseHandler(payload, 'CreateCompany') }

        case CoverActionTypes.CREATE_COMPANY_FULFILLED:
            let companyCreated=payload.data;
            return Object.assign({}, state, {
                companies:[
                    companyCreated,
                    ...state.companies
                ],
                successCreateCompany: true,
                createCompanyLoading: false
            })

        
        case CoverActionTypes.CREATE_CORPORATE_USER:
        case CoverActionTypes.CREATE_CORPORATE_USER_PENDING:
            return { ...state, createCorporateLoading: true }

        case CoverActionTypes.CREATE_CORPORATE_USER_REJECTED:
            return { ...state, createCorporateLoading: false, ...errorResponseHandler(payload, 'CreateCorporate') }

        case CoverActionTypes.CREATE_CORPORATE_USER_FULFILLED:
            let createdCorporateUser=payload.data;
            return Object.assign({}, state,{
                corporates:[
                    createdCorporateUser,
                    ...state.corporates
                ],
                createCorporateLoading: false, 
                successCreateCorporate: true
            })
        

        default:
           return state;
   }
}


// WEBPACK FOOTER //
// ./src/reducers/openCovers.js